import type { NetworkPublicInfoFields } from '@tribeplatform/gql-client/graphql'

import { KeyConstructor } from './keyConstructor.js'

const WORKSPACES_KEY = 'workspaces'

export const getWorkspacesKey = KeyConstructor<never, NetworkPublicInfoFields>(
  WORKSPACES_KEY,
)
